import { create } from "zustand";
import { persist } from "zustand/middleware";

type StoreState = {
  theme: string | undefined;
  updateTheme: (theme: string) => void;
};

export const useStore = create<StoreState>()(
  persist(
    (set) => ({
      theme: undefined,
      updateTheme: (theme: string) => set({ theme }),
    }),
    {
      name: "boi-react-design-tokens-store",
    }
  )
);

export default useStore;
